export default {
  API_URL: process.env.REACT_APP_API_URL || 'https://localhost:7500/qr',
  GOOGLE_TAG_MANAGER_KEY: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY || '',
  SEGMENT_KEY: process.env.REACT_APP_SEGMENT_KEY || '',
  INSPECTLET_KEY: process.env.REACT_APP_INSPECTLET_KEY || '',
}
